import type {
  IAttackPathCell,
  IAttackPathCoords
} from '@app/pages/AttackPath/types'
import type { Maybe } from '@server/graphql/typeDefs/types'
import type EntityAttackPathNode from './EntityAttackPathNode'
import EntityBase from './EntityBase'

export default abstract class EntityAttackPathBaseNode extends EntityBase {
  uid = ''

  cell?: IAttackPathCell

  linkedNodeEntity: Maybe<EntityAttackPathNode> = null

  x = 0
  y = 0
  depth = 0
  isSourceOfExpansion = false
  isPartOfExpansion = false
  isHiddenNode = false
  isImportantNode = false

  placed = false

  constructor() {
    super()
  }

  setCell(cell: IAttackPathCell): this {
    this.cell = cell

    return this
  }

  get coords(): IAttackPathCoords {
    return {
      x: this.x,
      y: this.y
    }
  }
}
